/**
 * Log to the console in non-production node environments
 * @internal
 */
export const DEBUG =
  process.env.NODE_ENV !== 'production' ? console.log : () => null;
